import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  checkIsDeleteServiceSubscriptionProvider,
  getSelectedValue,
  getSelectOptions,
} from './helper';
import * as types from '../../reducer/constants';
import SelectVirtualized from '../../../../../../../../components/Select/Virtualized';
import { getExceptionsTypes } from '../../helper';

const FieldServiceType = ({ form, modal, dispatchServiceData }) => {
  const { serviceTypes } = useSelector((state) => state.services);
  const { service_type } = form;

  const selectedValue = useMemo(() => getSelectedValue(serviceTypes, service_type), [serviceTypes, service_type]);
  const selectOptions = useMemo(() => getSelectOptions(serviceTypes), [serviceTypes])
  const isDisabled = useMemo(() => checkIsDeleteServiceSubscriptionProvider(modal), [modal])

  const onChange = (selected) => {
    const value = Number(selected.value);
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SERVICE_TYPE, value });

    /**
     * Если type exception
     * Надо выключить auto_complete
     */
    const exceptionsTypes = getExceptionsTypes();
    if (exceptionsTypes.includes(value)) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_AUTO_COMPLETE, value: false });
    }

    /**
     * Если service_type не поддерживает drip_feed и cancel
     * Надо выключить drip_feed или cancel
     */
    if (selected.hasOwnProperty('dripfeed') && !selected.dripfeed) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_DRIP_FEED, value: false })
    }
    if (selected.hasOwnProperty('cancel') && !selected.cancel) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_CANCEL, value: false })
    }
  };

  return (
    <FormGroup className="form-group__service-type">
      <ControlLabel>Service type</ControlLabel>
      <SelectVirtualized
        components={{ IndicatorSeparator: null }}
        onChange={onChange}
        noOptionsMessage={() => 'Not found service type'}
        hideSelectedOptions={false}
        value={selectedValue}
        options={selectOptions}
        name="service_type"
        placeholder="Choose service type"
        isDisabled={isDisabled}
      />
    </FormGroup>
  )
};

FieldServiceType.propTypes = {
  form: PropTypes.object,
  modal: PropTypes.object,
  dispatchServiceData: PropTypes.func.isRequired,
}

export default FieldServiceType;
